export default {
    name: 'dispatch',
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
        openquote(context,id) {
            let DB = localStorage.getItem(`DB`)
            return window.open(`${printApi}Quotes/${DB}/${id}`,`_blank`)
        },
        async fetchDebtor(context,id) {
            let DB = localStorage.getItem(`DB`)
            return await axios.get(`${pay}debtor/${DB}/getQuoteRate?quoteNumber=${id}`)
                .then(({data}) => data)
                .catch((error) => errorHandler.tomcatError(error))
        },
        async showStock(context,payload) {
            return await axios.get(`${synergyApi}jobcards/show-required-stocks/${payload.id}`,{
                params: { urlId: payload.urlId }
            })
                .then(({data}) => data)
                .catch((error) => errorHandler.tomcatError(error))
        },
        async fetchInitialState(context,payload) {
            return await axios.get(`${synergyApi}delivery/getDispatchDetails/${payload.id}`,{
                params: { urlId: payload.urlId }
            })
                .then(({data}) => data)
                .catch((error) => errorHandler.tomcatError(error))
        },
        async updateState(context, payload) {
            const url = `${synergyApi}delivery/updateDispatchDetails`;
            return await context.dispatch('sendRequest',{url, payload,})
        },
        async sendOtp(context, payload) {
            const url = `${synergyApi}delivery/confirmStockDelivery`;
            return await context.dispatch('sendRequest',{url, payload,})
        },
        async completed(context, payload) {
            const url = `${synergyApi}delivery/completeStockDelivery`;
            return await context.dispatch('sendRequest',{url, payload,})
        },
        async popValidation(context, payload) {
            let DB = localStorage.getItem(`DB`)
            const url = `${pay}popValidation/${DB}`;
            return await context.dispatch('sendRequest',{url, payload,})
        },
        async receiveIntegratedPayment(context, payload) {
            console.log(payload);
            let DB = localStorage.getItem(`DB`)
            const url = `${pay}popValidation/${DB}/receiveIntegratedPayment`;
            return await context.dispatch('sendRequest',{url, payload,})
        },
        async createTransaction(context, payload) {
            const url = `${gateway}GateWay/CreateTransaction`;
            payload.API_KEY = context.getters.getApiKey;
            console.log(payload);
            return await context.dispatch('sendRequest',{url, payload,})
                .then((data)=> window.open(`${data.url}`, '_blank'))
        },
    }
}
